import { render, staticRenderFns } from "./CartItemPreview.vue?vue&type=template&id=d65f2a5c"
import script from "./CartItemPreview.vue?vue&type=script&lang=js"
export * from "./CartItemPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports